import React from "react";

/**
 * Branded WhatsApp glyph (single-color so it inherits from `currentColor`).
 * Use `className` to size: e.g. <WhatsAppIcon className="w-4 h-4" />
 */
export default function WhatsAppIcon({ className = "w-4 h-4", title = "WhatsApp" }) {
  return (
    <svg
      role="img"
      aria-label={title}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M19.11 4.92A10 10 0 0 0 12.07 2C6.55 2 2.07 6.48 2.06 12a10 10 0 0 0 1.34 5L2 22l5.16-1.35A10 10 0 0 0 12.07 22h.01c5.52 0 10-4.48 10-10a9.94 9.94 0 0 0-2.97-7.08ZM12.08 20.32h-.01a8.32 8.32 0 0 1-4.24-1.16l-.31-.18-3.06.8.82-2.98-.2-.31a8.3 8.3 0 0 1-1.27-4.4c0-4.59 3.74-8.32 8.34-8.32a8.27 8.27 0 0 1 5.89 2.44 8.27 8.27 0 0 1 2.43 5.88c0 4.59-3.74 8.33-8.39 8.33Zm4.57-6.23c-.25-.13-1.49-.74-1.72-.82-.23-.08-.4-.13-.57.13-.17.25-.65.82-.8.99-.15.17-.3.18-.55.06-.25-.13-1.06-.39-2.02-1.24-.75-.66-1.25-1.48-1.4-1.73-.15-.25-.02-.39.11-.51.11-.11.25-.3.38-.45.13-.15.17-.25.25-.42.08-.17.04-.32-.02-.45-.06-.13-.57-1.37-.78-1.88-.21-.49-.42-.43-.57-.44-.15-.01-.32-.01-.49-.01-.17 0-.45.06-.69.32-.23.25-.9.88-.9 2.15s.92 2.49 1.05 2.66c.13.17 1.81 2.77 4.39 3.88.61.26 1.09.42 1.46.54.61.19 1.17.17 1.61.1.49-.07 1.49-.61 1.7-1.2.21-.59.21-1.1.15-1.2-.06-.1-.23-.17-.48-.29Z" />
    </svg>
  );
}
